var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEvBolt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 337.967,
    height: 492.132,
    viewBox: "0 0 337.967 492.132",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_466",
    "data-name": "Group 466",
    transform: "translate(103.143 150.191)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5745",
    "data-name": "Path 5745",
    d: "M292.072,247.141,172.456,210.573,234.333,8.1,11.94,241.945l119.617,36.568L69.679,480.986Z",
    transform: "translate(-115.083 -139.045)",
    fill: "#fff",
    opacity: 0.404
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5746",
    "data-name": "Path 5746",
    d: "M198.183,78.467,159.69,202.991l-5.581,18.38,18.38,5.582,89.881,27.426L118.022,406.619l38.493-124.525,5.582-18.38-18.477-5.582L53.738,230.706,198.087,78.467M240.429,6.1,17.94,239.945l119.617,36.568L75.679,478.6,298.169,244.756,178.552,208.188,240.429,6.1Z",
    transform: "translate(-63.344 -156.291)",
    fill: "#f6f8fa"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvBolt);
export default __webpack_public_path__ + "static/media/ev_bolt.3f27e249da4a4ae5eb41b67aba6b97df.svg";
export { ForwardRef as ReactComponent };